/**
 * /servicii-it (IT services) — migrated from public/js/it-serv.js.
 *
 * 1. navMenu pe header .menu-items care comuta .layer-1 .serv panels +
 *    activeaza wheel-t<N> + wheel-c<N> + scroll spre header.
 * 2. Click pe #wheel-c1..7 declanseaza click pe menu items corespunzatoare.
 * 3. Click pe a.btn-other in layer-1 scroll-uieste sus.
 */
import { Resort } from '../core/resort.js';

new Resort(() => {
    const menuBox  = $('header .menu-items') as Element | null;
    if (!menuBox) return;
    const menuItms = menuBox.find('a', true) as NodeListOf<Element>;

    menuBox.navMenu('a', '.layer-1 .serv', (index: number) => {
        $('.wheel-a', (el: Element) => { el.classList.remove('active'); return true; });
        ($(`.wheel-t${index + 1}`) as Element | null)?.classList.add('active');
        ($(`#wheel-c${index + 1}`) as Element | null)?.classList.add('active');

        const header = $('header') as HTMLElement | null;
        window.scrollTo({ top: header?.clientHeight ?? 0, behavior: 'smooth' });
    });

    for (let i = 1; i <= 7; i++) {
        ($(`#wheel-c${i}`) as Element | null)?.on('click', () => {
            menuItms.item(i - 1)?.dispatchEvent(new Event('click'));
        });
    }

    ($('.layer-1') as Element | null)?.on('click', 'a.btn-other', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
});
